import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Injectable, Injector, NgZone } from '@angular/core';
import { ApplicationLog, ErroLoggingService } from './errorlogging.service';
import { AppSettings } from '../configuration/appsettings.config';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { DataShareService } from './datashare.service'



@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private ngZone: NgZone, private injector: Injector, private errorHandlerLoggingService: ErroLoggingService, private dataShareService: DataShareService) { }
  handleError(error: any) {
   
    let router = this.injector.get(Router);
    let msg: ApplicationLog = {
      message: error.message,
      participantId: AppSettings.getParticipantID(),
      stack: error.stack,
      url: router.url == null ? "" : router.url,
      certificationId: AppSettings.getCertificationID(),
      participantCode: AppSettings.getParticipantID(),
      referenceNumber: AppSettings.getReferenceNumber(),
    };
   
    //If dev mode then Log Error to consol...
    if (!environment.production) {
      console.log(error.message);
      console.log(error.stack);
      
    }
    else {
     
      this.errorHandlerLoggingService.log(msg);
    }
  }

}
